export const getPeriodType = (periodType, movingType) => {
  if (periodType === 'rollingDays') {
    return movingType === 'calendar' ? 'moving' : 'available_moving'
  }

  return periodType
}
